import { usePost } from "./usePost";

const PATH = "/api/login-code-mfa";

export const useSubmitEmailMfaCode = () => {
  const { onSubmit, loading, error, setError, data } = usePost(PATH, 10_000);

  // Automatically redirect on successful submission
  // Return the error if the submission fails
  return {
    onSubmitEmailMfaCode: onSubmit,
    loadingEmailMfaCode: loading,
    emailMfaCodeError: error,
    setEmailMfaCodeError: setError,
    emailMfaCodeData: data,
  };
};
